import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import './Legal.css';

const Terms = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const isEn = lang === 'en';
  const isVi = lang === 'vi';
  const isZh = lang === 'zh';
  const isFr = lang === 'fr';

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">
          <IoArrowBack />
          <span>{t('common.home') || 'Home'}</span>
        </Link>

        <h1>{t('footer.terms')}</h1>

        <div className="legal-content">
          {isEn && (
            <>
              <section>
                <h2>1. {t('legal.acceptance') || 'Acceptance of Terms'}</h2>
                <p>By accessing and using emoozi ("the Service"), you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our Service.</p>
              </section>

              <section>
                <h2>2. {t('legal.description') || 'Description of Service'}</h2>
                <p>emoozi is a private social network platform that allows users to share moments, chat with family and friends, and stay connected in a private, algorithm-free environment.</p>
              </section>

              <section>
                <h2>3. {t('legal.legalBasis') || 'Legal Basis'}</h2>
                <p>This Terms of Use is prepared in compliance with Vietnam Cybersecurity Law No. 24/2018/QH14, Civil Code of Vietnam, Law on Information Security, and Law on Protection of Consumer Rights.</p>
              </section>

              <section>
                <h2>4. {t('legal.registration') || 'User Registration and Account'}</h2>
                <p>4.1. You must provide accurate, complete, and up-to-date registration information.<br/>
                4.2. You are responsible for maintaining the confidentiality of your account credentials.<br/>
                4.3. You must be at least 13 years of age to use this Service.<br/>
                4.4. You are solely responsible for all activities under your account.<br/>
                4.5. You must provide valid identification when required by law.</p>
              </section>

              <section>
                <h2>5. {t('legal.userObligations') || 'User Obligations'}</h2>
                <p>You agree to: (a) Comply with Vietnamese laws and these Terms of Use; (b) Provide accurate and complete personal information; (c) Not use the Service for unlawful purposes; (d) Not infringe upon the rights and legitimate interests of others; (e) Promptly update your information when changes occur; (f) Accept responsibility for all activities under your account.</p>
              </section>

              <section>
                <h2>6. {t('legal.prohibited') || 'Prohibited Activities'}</h2>
                <p>You agree NOT to use the Service to: (a) Organize or participate in acts against the State of the Socialist Republic of Vietnam; (b) Incite violence, discrimination, or hatred; (c) Spread false or misleading information; (d) Infringe upon national security, national defense, social safety, or public order; (e) Infringe upon intellectual property rights, privacy, or other legal rights of others; (f) Hack, spread viruses, malware, or harmful code; (g) Use another person's account without authorization; (h) Post or share prohibited content as defined by Vietnamese law; (i) Obstruct or disrupt the Service operations.</p>
              </section>

              <section>
                <h2>7. {t('legal.userContent') || 'User-Generated Content'}</h2>
                <p>7.1. You retain ownership of content you post on emoozi.<br/>
                7.2. By posting content, you grant us a limited license to display and manage your content on our platform.<br/>
                7.3. You represent and warrant that you have all rights to the content you post.<br/>
                7.4. We reserve the right to remove content that violates these Terms or Vietnamese law.</p>
              </section>

              <section>
                <h2>8. {t('legal.privacyData') || 'Privacy and Data Protection'}</h2>
                <p>8.1. We are committed to protecting your privacy and personal data in accordance with Vietnam's Law on Information Security.<br/>
                8.2. We collect and process personal data only as necessary to provide our Service.<br/>
                8.3. Your data is stored securely and will not be sold to third parties.<br/>
                8.4. You have the right to access, correct, or delete your personal data.<br/>
                8.5. For detailed information, please review our Privacy Policy.</p>
              </section>

              <section>
                <h2>9. {t('legal.platformResponsibilities') || 'Platform Responsibilities'}</h2>
                <p>We commit to: (a) Implement measures to protect cybersecurity in accordance with the law; (b) Remove prohibited content when detected or upon request from authorities; (c) Cooperate with Vietnamese authorities in preventing and handling cybersecurity incidents; (d) Store user data securely and protect against unauthorized access; (e) Provide mechanisms for users to report violations.</p>
              </section>

              <section>
                <h2>10. {t('legal.liability') || 'Limitation of Liability'}</h2>
                <p>10.1. The Service is provided "as is" without any warranties.<br/>
                10.2. We do not guarantee that the Service will be uninterrupted or error-free.<br/>
                10.3. We shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.<br/>
                10.4. You shall be liable for any damages caused by your violation of these Terms or Vietnamese law.</p>
              </section>

              <section>
                <h2>11. {t('legal.termination') || 'Termination'}</h2>
                <p>11.1. We reserve the right to suspend or terminate your account at any time for violations of these Terms or Vietnamese law.<br/>
                11.2. Upon termination, your right to use the Service will immediately cease.<br/>
                11.3. You may delete your account at any time through your account settings.</p>
              </section>

              <section>
                <h2>12. {t('legal.changesTerms') || 'Changes to Terms'}</h2>
                <p>We may update these Terms from time to time to comply with changes in Vietnamese law or to improve our Service. Continued use of the Service after changes constitutes acceptance of the new Terms.</p>
              </section>

              <section>
                <h2>13. {t('legal.governingLaw') || 'Governing Law and Dispute Resolution'}</h2>
                <p>13.1. These Terms shall be governed by and construed in accordance with the laws of Vietnam.<br/>
                13.2. Any disputes arising from these Terms shall be resolved in accordance with Vietnamese law.</p>
              </section>

              <section>
                <h2>14. {t('legal.contact') || 'Contact Information'}</h2>
                <p>If you have questions about these Terms, please contact us at: qa@emoozi.com</p>
              </section>
            </>
          )}

          {isVi && (
            <>
              <section>
                <h2>1. {t('legal.acceptance') || 'Chấp Nhận Điều Khoản'}</h2>
                <p>Bằng việc truy cập và sử dụng emoozi ("Dịch vụ"), bạn đồng ý bị ràng buộc bởi các Điều Khoản Sử Dụng này. Nếu bạn không đồng ý với các điều khoản, vui lòng không sử dụng Dịch vụ của chúng tôi.</p>
              </section>

              <section>
                <h2>2. {t('legal.description') || 'Mô Tả Dịch Vụ'}</h2>
                <p>emoozi là nền tảng mạng xã hội riêng tư cho phép người dùng chia sẻ khoảnh khắc, nhắn tin với gia đình và bạn bè, cũng như giữ liên lạc trong môi trường không có thuật toán.</p>
              </section>

              <section>
                <h2>3. {t('legal.legalBasis') || 'Cơ Sở Pháp Lý'}</h2>
                <p>Điều Khoản Sử Dụng này được xây dựng tuân thủ Luật An Ninh Mạng số 24/2018/QH14, Bộ Luật Dân sự Việt Nam, Luật An Toàn Thông Tin Mạng, và Luật Bảo Vệ Quyền Lợi Người Tiêu Dùng.</p>
              </section>

              <section>
                <h2>4. {t('legal.registration') || 'Đăng Ký Tài Khoản Người Dùng'}</h2>
                <p>4.1. Bạn phải cung cấp thông tin đăng ký chính xác, đầy đủ và cập nhật.<br/>
                4.2. Bạn chịu trách nhiệm bảo mật thông tin đăng nhập của mình.<br/>
                4.3. Bạn phải từ 13 tuổi trở lên để sử dụng Dịch vụ này.<br/>
                4.4. Bạn chịu trách nhiệm cho mọi hoạt động dưới tài khoản của mình.<br/>
                4.5. Bạn phải cung cấp giấy tờ hợp lệ khi được yêu cầu theo quy định pháp luật.</p>
              </section>

              <section>
                <h2>5. {t('legal.userObligations') || 'Nghĩa Vụ Người Dùng'}</h2>
                <p>Bạn đồng ý: (a) Tuân thủ pháp luật Việt Nam và Điều Khoản Sử Dụng này; (b) Cung cấp thông tin cá nhân chính xác và đầy đủ; (c) Không sử dụng Dịch vụ cho mục đích bất hợp pháp; (d) Không xâm phạm quyền và lợi ích hợp pháp của người khác; (e) Cập nhật thông tin khi có thay đổi; (f) Chịu trách nhiệm về mọi hoạt động dưới tài khoản của mình.</p>
              </section>

              <section>
                <h2>6. {t('legal.prohibited') || 'Các Hành Vi Bị Cấm'}</h2>
                <p>Bạn đồng ý KHÔNG sử dụng Dịch vụ để: (a) Tổ chức hoặc tham gia các hành vi chống Nhà nước Cộng hòa Xã hội chủ nghĩa Việt Nam; (b) Kích động bạo lực, phân biệt đối xử hoặc thù địch; (c) Truyền bá thông tin sai sự thật gây hoang mang; (d) Xâm phạm an ninh quốc gia, quốc phòng, an toàn xã hội; (e) Xâm phạm quyền sở hữu trí tuệ, quyền riêng tư; (f) Hack, phát tán virus, phần mềm độc hại; (g) Sử dụng tài khoản của người khác mà không được phép; (h) Đăng tải nội dung bị cấm; (i) Cản trở hoạt động của Dịch vụ.</p>
              </section>

              <section>
                <h2>7. {t('legal.userContent') || 'Nội Dung Người Dùng'}</h2>
                <p>7.1. Bạn giữ quyền sở hữu nội dung bạn đăng trên emoozi.<br/>
                7.2. Bằng việc đăng nội dung, bạn cấp cho chúng tôi giấy phép để hiển thị và quản lý nội dung của bạn.<br/>
                7.3. Bạn tuyên bố và đảm bảo rằng bạn có tất cả quyền đối với nội dung bạn đăng.<br/>
                7.4. Chúng tôi có quyền xóa nội dung vi phạm Điều Khoản này hoặc pháp luật Việt Nam.</p>
              </section>

              <section>
                <h2>8. {t('legal.privacyData') || 'Quyền Riêng Tư và Bảo Vệ Dữ Liệu'}</h2>
                <p>8.1. Chúng tôi cam kết bảo vệ quyền riêng tư và dữ liệu cá nhân của bạn theo Luật An Toàn Thông Tin Mạng Việt Nam.<br/>
                8.2. Chúng tôi thu thập và xử lý dữ liệu cá nhân chỉ khi cần thiết để cung cấp Dịch vụ.<br/>
                8.3. Dữ liệu của bạn được lưu trữ an toàn và sẽ không được bán cho bên thứ ba.<br/>
                8.4. Bạn có quyền truy cập, chỉnh sửa hoặc xóa dữ liệu cá nhân của mình.<br/>
                8.5. Để biết thông tin chi tiết, vui lòng xem Chính Sách Quyền Riêng Tư.</p>
              </section>

              <section>
                <h2>9. {t('legal.platformResponsibilities') || 'Trách Nhiệm Nền Tảng'}</h2>
                <p>Chúng tôi cam kết: (a) Thực hiện các biện pháp bảo vệ an ninh mạng theo quy định pháp luật; (b) Xóa nội dung bị cấm khi phát hiện; (c) Phối hợp với cơ quan chức năng Việt Nam; (d) Lưu trữ dữ liệu người dùng an toàn; (e) Cung cấp cơ chế để người dùng báo cáo vi phạm.</p>
              </section>

              <section>
                <h2>10. {t('legal.liability') || 'Giới Hạn Trách Nhiệm'}</h2>
                <p>10.1. Dịch vụ được cung cấp "nguyên trạng" không có bảo đảm nào.<br/>
                10.2. Chúng tôi không đảm bảo rằng Dịch vụ sẽ không bị gián đoạn hoặc không có lỗi.<br/>
                10.3. Chúng tôi không chịu trách nhiệm cho bất kỳ thiệt hại gián tiếp nào.<br/>
                10.4. Bạn chịu trách nhiệm về mọi thiệt hại gây ra do vi phạm Điều Khoản này.</p>
              </section>

              <section>
                <h2>11. {t('legal.termination') || 'Chấm Dứt'}</h2>
                <p>11.1. Chúng tôi có quyền đình chỉ hoặc chấm dứt tài khoản của bạn bất kỳ lúc nào khi vi phạm Điều Khoản này.<br/>
                11.2. Khi chấm dứt, quyền sử dụng Dịch vụ của bạn sẽ chấm dứt ngay lập tức.<br/>
                11.3. Bạn có thể xóa tài khoản của mình bất kỳ lúc nào thông qua cài đặt tài khoản.</p>
              </section>

              <section>
                <h2>12. {t('legal.changesTerms') || 'Thay Đổi Điều Khoản'}</h2>
                <p>Chúng tôi có thể cập nhật các Điều Khoản này theo thời gian để tuân thủ các thay đổi trong pháp luật Việt Nam. Việc tiếp tục sử dụng Dịch vụ sau khi thay đổi đồng nghĩa với việc chấp nhận các Điều Khoản mới.</p>
              </section>

              <section>
                <h2>13. {t('legal.governingLaw') || 'Luật Điều Chỉnh'}</h2>
                <p>13.1. Các Điều Khoản này được điều chỉnh và giải thích theo pháp luật Việt Nam.<br/>
                13.2. Mọi tranh chấp phát sinh từ các Điều Khoản này sẽ được giải quyết theo pháp luật Việt Nam.</p>
              </section>

              <section>
                <h2>14. {t('legal.contact') || 'Thông Tin Liên Hệ'}</h2>
                <p>Nếu bạn có câu hỏi về các Điều Khoản này, vui lòng liên hệ với chúng tôi tại: qa@emoozi.com</p>
              </section>
            </>
          )}

          {isZh && (
            <>
              <section>
                <h2>1. {t('legal.acceptance') || '接受条款'}</h2>
                <p>访问和使用emoozi（"服务"）即表示您同意受这些服务条款的约束。如果您不同意这些条款，请不要使用我们的服务。</p>
              </section>

              <section>
                <h2>2. {t('legal.description') || '服务描述'}</h2>
                <p>emoozi是一个私人社交网络平台，允许用户分享时刻、与家人和朋友聊天，并在无算法的私密环境中保持联系。</p>
              </section>

              <section>
                <h2>3. {t('legal.legalBasis') || '法律依据'}</h2>
                <p>本服务条款根据越南网络安全法第24/2018/QH14号、越南民法、信息安全法和消费者权益保护法制定。</p>
              </section>

              <section>
                <h2>4. {t('legal.registration') || '用户注册和账户'}</h2>
                <p>4.1. 您必须提供准确、完整和最新的注册信息。<br/>
                4.2. 您有责任保护您的账户凭据的机密性。<br/>
                4.3. 您必须年满13岁才能使用本服务。<br/>
                4.4. 您对账户下的所有活动承担全部责任。<br/>
                4.5. 根据法律要求，您必须提供有效身份证件。</p>
              </section>

              <section>
                <h2>5. {t('legal.userObligations') || '用户义务'}</h2>
                <p>您同意：(a) 遵守越南法律和本服务条款；(b) 提供准确完整的个人信息；(c) 不将服务用于非法目的；(d) 不侵犯他人的权利和合法利益；(e) 信息变更时及时更新；(f) 对账户下的所有活动负责。</p>
              </section>

              <section>
                <h2>6. {t('legal.prohibited') || '禁止行为'}</h2>
                <p>您同意不使用服务进行：(a) 组织或参与反对越南社会主义共和国国家的行为；(b) 煽动暴力、歧视或仇恨；(c) 传播虚假或误导性信息；(d) 侵犯国家安全、国防、社会安全或公共秩序；(e) 侵犯他人知识产权、隐私或其他合法权益；(f) 黑客攻击、传播病毒、恶意软件或有害代码；(g) 未经授权使用他人账户；(h) 发布或分享越南法律禁止的内容；(i) 妨碍或扰乱服务运营。</p>
              </section>

              <section>
                <h2>7. {t('legal.userContent') || '用户生成内容'}</h2>
                <p>7.1. 您保留在emoozi上发布内容的所有权。<br/>
                7.2. 通过发布内容，您授予我们在平台上展示和管理内容的有限许可。<br/>
                7.3. 您声明并保证您对发布的内容拥有所有权利。<br/>
                7.4. 我们有权删除违反这些条款或越南法律的内容。</p>
              </section>

              <section>
                <h2>8. {t('legal.privacyData') || '隐私和数据保护'}</h2>
                <p>8.1. 我们承诺根据越南信息安全法保护您的隐私和个人数据。<br/>
                8.2. 我们仅在提供服务的必要范围内收集和处理个人数据。<br/>
                8.3. 您的数据被安全存储，不会出售给第三方。<br/>
                8.4. 您有权访问、更正或删除您的个人数据。<br/>
                8.5. 详细信息请查看我们的隐私政策。</p>
              </section>

              <section>
                <h2>9. {t('legal.platformResponsibilities') || '平台责任'}</h2>
                <p>我们承诺：(a) 依法采取网络安全保护措施；(b) 发现或根据当局要求删除禁止内容；(c) 与越南当局合作预防和处理网络安全事件；(d) 安全存储用户数据并防止未经授权的访问；(e) 为用户提供举报违规的机制。</p>
              </section>

              <section>
                <h2>10. {t('legal.liability') || '责任限制'}</h2>
                <p>10.1. 服务按原样提供，不提供任何保证。<br/>
                10.2. 我们不保证服务不会中断或无错误。<br/>
                10.3. 我们不对您使用服务导致的任何间接、偶然或后果性损害负责。<br/>
                10.4. 您应对违反这些条款或越南法律造成的任何损害负责。</p>
              </section>

              <section>
                <h2>11. {t('legal.termination') || '终止'}</h2>
                <p>11.1. 我们有权随时暂停或终止违反这些条款或越南法律的账户。<br/>
                11.2. 终止后，您使用服务的权利将立即终止。<br/>
                11.3. 您可以随时通过账户设置删除您的账户。</p>
              </section>

              <section>
                <h2>12. {t('legal.changesTerms') || '条款变更'}</h2>
                <p>我们可能随时更新这些条款以符合越南法律的变化或改进我们的服务。在更改后继续使用服务即表示接受新条款。</p>
              </section>

              <section>
                <h2>13. {t('legal.governingLaw') || '管辖法律和争议解决'}</h2>
                <p>13.1. 这些条款应按照越南法律进行解释和管辖。<br/>
                13.2. 因这些条款产生的任何争议应按照越南法律解决。</p>
              </section>

              <section>
                <h2>14. {t('legal.contact') || '联系信息'}</h2>
                <p>如果您对这些条款有疑问，请联系我们：qa@emoozi.com</p>
              </section>
            </>
          )}

          {isFr && (
            <>
              <section>
                <h2>1. {t('legal.acceptance') || 'Acceptation des conditions'}</h2>
                <p>En accédant et en utilisant emoozi ("le Service"), vous acceptez d'être lié par ces Conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre Service.</p>
              </section>

              <section>
                <h2>2. {t('legal.description') || 'Description du Service'}</h2>
                <p>emoozi est une plateforme de réseau social privé qui permet aux utilisateurs de partager des moments, de discuter avec leur famille et leurs amis, et de rester connectés dans un environnement privé sans algorithme.</p>
              </section>

              <section>
                <h2>3. {t('legal.legalBasis') || 'Base légale'}</h2>
                <p>Ces Conditions d'utilisation sont élaborées conformément à la Loi vietnamienne sur la cybersécurité n° 24/2018/QH14, au Code civil vietnamien, à la Loi sur la sécurité de l'information et à la Loi sur la protection des droits des consommateurs.</p>
              </section>

              <section>
                <h2>4. {t('legal.registration') || 'Inscription et compte utilisateur'}</h2>
                <p>4.1. Vous devez fournir des informations d'inscription précises, complètes et à jour.<br/>
                4.2. Vous êtes responsable de la confidentialité de vos identifiants de compte.<br/>
                4.3. Vous devez avoir au moins 13 ans pour utiliser ce Service.<br/>
                4.4. Vous êtes seul responsable de toutes les activités sous votre compte.<br/>
                4.5. Vous devez fournir une pièce d'identité valide si la loi l'exige.</p>
              </section>

              <section>
                <h2>5. {t('legal.userObligations') || 'Obligations de l\'utilisateur'}</h2>
                <p>Vous acceptez de : (a) Respecter les lois vietnamiennes et ces Conditions d'utilisation ; (b) Fournir des informations personnelles précises et complètes ; (c) Ne pas utiliser le Service à des fins illégales ; (d) Ne pas porter atteinte aux droits et intérêts légitimes d'autrui ; (e) Mettre à jour vos informations en cas de changement ; (f) Assumer la responsabilité de toutes les activités sous votre compte.</p>
              </section>

              <section>
                <h2>6. {t('legal.prohibited') || 'Activités interdites'}</h2>
                <p>Vous acceptez de NE PAS utiliser le Service pour : (a) Organiser ou participer à des actes contre l'État vietnamien ; (b) Inciter à la violence, à la discrimination ou à la haine ; (c) Diffuser des informations fausses ou trompeuses ; (d) Porter atteinte à la sécurité nationale, à la défense, à la sécurité sociale ou à l'ordre public ; (e) Porter atteinte aux droits de propriété intellectuelle, à la vie privée ou aux droits légaux d'autrui ; (f) Hacker, diffuser des virus, des logiciels malveillants ou du code nuisible ; (g) Utiliser le compte d'autrui sans autorisation ; (h) Publier ou partager du contenu interdit par la loi vietnamienne ; (i) Entraver ou perturber le fonctionnement du Service.</p>
              </section>

              <section>
                <h2>7. {t('legal.userContent') || 'Contenu généré par l\'utilisateur'}</h2>
                <p>7.1. Vous conservez la propriété du contenu que vous publiez sur emoozi.<br/>
                7.2. En publikant du contenu, vous nous accordez une licence limitée pour afficher et gérer votre contenu sur notre plateforme.<br/>
                7.3. Vous déclarez et garantissez que vous avez tous les droits sur le contenu que vous publiez.<br/>
                7.4. Nous nous réservons le droit de supprimer tout contenu violant ces Conditions ou la loi vietnamienne.</p>
              </section>

              <section>
                <h2>8. {t('legal.privacyData') || 'Vie privée et protection des données'}</h2>
                <p>8.1. Nous nous engageons à protéger votre vie privée et vos données personnelles conformément à la Loi vietnamienne sur la sécurité de l'information.<br/>
                8.2. Nous collectons et traitons les données personnelles uniquement si nécessaire pour fournir notre Service.<br/>
                8.3. Vos données sont stockées de manière sécurisée et ne seront pas vendues à des tiers.<br/>
                8.4. Vous avez le droit d'accéder, de corriger ou de supprimer vos données personnelles.<br/>
                8.5. Pour plus d'informations, veuillez consulter notre Politique de confidentialité.</p>
              </section>

              <section>
                <h2>9. {t('legal.platformResponsibilities') || 'Responsabilités de la plateforme'}</h2>
                <p>Nous nous engageons à : (a) Mettre en œuvre des mesures de protection de la cybersécurité conformément à la loi ; (b) Supprimer le contenu interdit lorsqu'il est détecté ou sur demande des autorités ; (c) Coopérer avec les autorités vietnamiennes pour prévenir et gérer les incidents de cybersécurité ; (d) Stocker les données utilisateur de manière sécurisée et les protéger contre tout accès non autorisé ; (e) Fournir des mécanismes pour signaler les violations.</p>
              </section>

              <section>
                <h2>10. {t('legal.liability') || 'Limitation de responsabilité'}</h2>
                <p>10.1. Le Service est fourni "en l'état" sans aucune garantie.<br/>
                10.2. Nous ne garantissons pas que le Service sera ininterrompu ou sans erreur.<br/>
                10.3. Nous ne serons pas responsables des dommages indirects, accessoires ou consécutifs résultant de votre utilisation du Service.<br/>
                10.4. Vous serez responsable de tout dommage causé par votre violation de ces Conditions ou de la loi vietnamienne.</p>
              </section>

              <section>
                <h2>11. {t('legal.termination') || 'Résiliation'}</h2>
                <p>11.1. Nous nous réservons le droit de suspendre ou de résilier votre compte à tout moment en cas de violation de ces Conditions ou de la loi vietnamienne.<br/>
                11.2. Upon Upon résiliation, votre droit d'utiliser le Service cessera immédiatement.<br/>
                11.3. Vous pouvez supprimer votre compte à tout moment via les paramètres de votre compte.</p>
              </section>

              <section>
                <h2>12. {t('legal.changesTerms') || 'Modifications des conditions'}</h2>
                <p>Nous pouvons mettre à jour ces Conditions de temps à autre pour nous conformer aux changements de la loi vietnamienne ou pour améliorer notre Service. L'utilisation continue du Service après les modifications constitue l'acceptation des nouvelles Conditions.</p>
              </section>

              <section>
                <h2>13. {t('legal.governingLaw') || 'Droit applicable et règlement des litiges'}</h2>
                <p>13.1. Ces Conditions seront régies et interprétées conformément aux lois du Vietnam.<br/>
                13.2. Tout litige découlant de ces Conditions sera résolu conformément au droit vietnamien.</p>
              </section>

              <section>
                <h2>14. {t('legal.contact') || 'Coordonnées'}</h2>
                <p>Si vous avez des questions sur ces Conditions, veuillez nous contacter à : qa@emoozi.com</p>
              </section>
            </>
          )}

          <p className="legal-updated">
            {t('legal.lastUpdated') || 'Last updated'}: March 4, 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
